import React, { useState, useEffect } from "react";
import {
Row,
Col,
Menu,
Tag,
Select,
Rate,
Skeleton,
Comment,
Spin } from
"antd";
import { HeartFilled } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";

import { FiUserCheck } from "react-icons/fi";
import {
BsFacebook,
BsLinkedin,
BsStackOverflow,
BsTelephone } from
"react-icons/bs";
import { GrGithub } from "react-icons/gr";
import { TfiLocationPin } from "react-icons/tfi";
import { AiOutlineMail } from "react-icons/ai";
import ExpIcon from "../../assets/img/ExpIcon.png";
import Reviews from "./Reviews/Reviews";
import citizen from "../../assets/icons/citizen.png";
import CertificationAndAward from "./certificationsAndAwards/certificationAndAward";
import { DownloadOutlined } from "@ant-design/icons";
import SSN from "../../assets/icons/SSN.svg";
import stateLicense from "../../assets/icons/stateLicense.svg";
import Invitedemail from "../../assets/icons/Invitedemail.svg";
import invitedNumber from "../../assets/icons/invitedNumber.svg";
import backButton from "../../assets/icons/backButton.svg";
import {
fetchProfileDetails,
getOneUserSkillListing,
postFavorites,
deleteFavorites,
isModalVisibleAuth,
getNotes,
clearRetractBid,
clearUpdateBidSuccess,
getConversationId,
FavReset,
resetHeader } from
"../../redux/actions";
import moment from "moment";
import threeDicon from "../../assets/icons/clinical_notes.svg";
import schedule_icon from "../../assets/img/schedule_icon.png";
import schedule_icon_fade from "../../assets/icons/healthicons_i-schedule-school-date-time-outline.png";
import schedule_icon_disable from "../../assets/icons/healthicons_i-schedule-school-date-time-outline.png";
import cil_chat_bubble from "../../assets/img/cil_chat-bubble.png";
import cil_chat_bubble_faded from "../../assets/icons/colorless_cil_chat-bubble.png";
import history from "../../routes/history";
import TopAlert from "../../components/TopNotification/TopAlert";
import {
HiredStatusbtns,
MatchesButton,
PlacedBidBtns } from
"./ButtonsSet/BottomBtns";
import PlaceBidModal from "../../components/PlaceBidModal/PlaceBidModal";
import InterviewDrawer from "./InterviewDrawer/interviewDrawer";
import axios from "axios";
import SkillListing from "./skill-Listing/index";
import EducationHistory from "./EducationHistory/educationHistory";
import WorkHistory from "./WorkHistory/WorkHistory";
import AddNotes from "./Notes";
import UserCredentials from "./credentials/credentials";
import Loader from "../../components/Loading/Loader";
import InfoIcon from "../../assets/icons/InfoIcon.svg";

import { LoadingOutlined } from "@ant-design/icons";
import { DefaultRating } from "../../assets/helpers";
import { formatDate, formatPhoneNumber, getCookie, isHC, isNonHC } from "../../shared/helpers";
import PrivateTagSkillListing from "../../components/PrivateMarketComponents/PrivateTagSkillListing";
import PopupModal from "../3dResume/components/PopupModal/PopupModal";
import PlaceBidDisclaimer from "./PlaceBidDisclaimer/PlaceBidDisclaimer";
import { TAL_AUTO_SUGGESTED } from "../../shared/constants";
import { EmailCard } from "../../components/EmailCard";
import "./ProfileD.css";

const BackendApiBaseUrl = process.env.REACT_APP_API_URL;

const ProfileDetail = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isInvited = props?.isInvited || false;
  const authToken = getCookie("token");
  const { id } = useParams();
  const [Pdetails, setPdetails] = useState([]);
  //Hooks
  const [InterviewSchedule, setInterviewSchedule] = useState(false);
  const [placebidModal, setplacebidModal] = useState(false);
  const [favorite, setFavorite] = React.useState(false);
  const [displayModal, setDisplayModal] = useState(false);
  const [marginVal, setMarginVal] = useState();
  const [color, setColor] = useState("");
  const [stars, setStar] = useState(DefaultRating);
  const [windowDimensions, setWindowDimensions] = useState(
  getWindowDimensions());

  const [interviewDrawer, setinterviewDrawer] = useState(false);
  const [bidId, setbidId] = useState(false);
  const [bidDeclinedStatus, setBidDeclinedStatus] = useState(false);
  const skillloading = useSelector(
  (state) => state.oneUserskillListingReducer.loading);

  const [menuClicked, setMenuClicked] = useState("Skill Listing");
  const professionCode = JSON.parse(localStorage.getItem("userProfile"));
  const [deletedSkilllistingCheck, setDeletedSkilllistingCheck] =
  useState(false);
  const [resumeCheck, setResumeCheck] = useState(false);
  const [error, setError] = useState(false);
  const [HidePagePvt, setHidePagePvt] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [popUpTrue, setpopUpTrue] = useState(false);
  const [alreadyPlacedBid, setAlreadyPlacedBid] = useState(false);
  const [showResumeButton, setShowResumeButton] = useState(true);

  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const [userProfileState, setuserProfileState] = useState(userProfile);

  const authTokenValue = useSelector(
  (state) => state.authReducer.user.authToken);

  const Previews = useSelector(
  (state) => state.getProfileDetailsReducer.reviewsDetails);

  const msgsId = useSelector(
  (state) => state.getProfileDetailsReducer.conversationID);

  // here we are getting the profile details of the guest user 
  const profileDetailsGuest = useSelector(
  (state) => state.getProfileDetailsReducer.details);

  const loading = useSelector(
  (state) => state.getProfileDetailsReducer.loading);


  // here getskilllisting api
  const userSKillListing = useSelector(
  (state) => state.oneUserskillListingReducer.skillListings);


  const employerEmail =
  userSKillListing?.user_Schema?.TalentInvitedBy?.[0]?.EmployerEmail;
  const employerName =
  userSKillListing?.user_Schema?.TalentInvitedBy?.[0]?.EmployerName;
  const inviteDate =
  userSKillListing?.user_Schema?.TalentInvitedBy?.[0]?.InviteDate;
  const [match, setMatch] = useState(false);
  let URL = "";
  const get_favorite = useSelector(
  (state) => state.oneUserskillListingReducer.isFav);


  const removePvtLoading = useSelector(
  (state) => state.getProfileDetailsReducer.loadingPrivate);


  const showBackButton = location.state?.fromSpecificRedirect;

  const handleBack = () => {
    history.goBack();
  };

  const removePvtResponse = useSelector(
    (state) => state.getProfileDetailsReducer.RemoveTalentPrivate
  );

  const isHiredOrOfferAccepted = () => Pdetails?.user_Schema?.hired == true || Pdetails?.user_Schema?.isBidBlocked === true
  
  

  useEffect(() => {
    dispatch(FavReset());
    setColor("");
  }, []);

  useEffect(() => {
    if (location.state?.reopenPlaceBid) {
      setplacebidModal(true);
    }
  }, [location.state]);

  useEffect(() => {
    setPdetails(profileDetailsGuest);
  }, [profileDetailsGuest]);

  useEffect(() => {
    if (Pdetails?.user_Schema?.Profiles?.TalentDocuments?.length > 0) {
      const resumeURL = Pdetails?.user_Schema?.Profiles?.TalentDocuments.filter(
      (doc) =>
      doc?.CredentialDocument?.CredentialDocumentName.includes("Resume"));

      setResumeCheck(resumeURL);
    }
  }, [Pdetails?.user_Schema?.Profiles?.TalentDocuments]);

  useEffect(() => {
    setStar(
    Pdetails?.user_Schema?.Profiles?.Rating === 0 ||
    Pdetails?.user_Schema?.Profiles?.Rating === null ||
    Pdetails?.user_Schema?.Profiles?.Rating === undefined ?
    DefaultRating :
    parseFloat(Pdetails?.user_Schema?.Profiles?.Rating));

  }, [Pdetails?.user_Schema]);
  const favLoading = useSelector(
  (state) => state.oneUserskillListingReducer.loadingFav);


  const favourite_status = useSelector(
  (state) => state.oneUserskillListingReducer.favStatus);


  const RetractSuccess = useSelector(
  (state) => state.retractBidReducers.success);

  const Retract = useSelector((state) => state.retractBidReducers.retract);
  const BidSuccess = useSelector((state) => state.createBidReducers.success);

  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    if (!authTokenValue)
    {
      handleFetchProfileDetails(location.state?.id);
    }
  }, [location.state]);

  const disableDownloadButton = (value) => {
    setShowResumeButton(value);
    if (!authTokenValue) {
      handleFetchProfileDetails();
    } else {
      dispatch(
      getOneUserSkillListing({
        skillId: location.state?.id || location?.pathname?.split("profiledetail/")?.[1],
        jobId:
        location.state?.jobId ||
        location?.search?.split("jobId=")?.[1]?.split("&")?.[0]
      }));

    }
  };
  // here
  const handleFetchProfileDetails = () => {
    try {
      dispatch(
      fetchProfileDetails(
      location.state?.id || location?.pathname?.split("profiledetail/")?.[1]));


    } catch (error) {}
  };

  useEffect(() => {
    userSKillListing?.isMatch === true ? setMatch(true) : setMatch(false);

    if (userSKillListing)
    setPdetails({ ...(userSKillListing || {}), skill_listings: [userSKillListing?.skill_listings || {}] });
  }, [userSKillListing]);

  const placeABidFunction = () => {
    if (authToken !== null && authToken !== "") {
      if (
      userSKillListing?.skill_listings?.SkillListingStatuses?.
      SkillListingStatusId == 3)
      {
        setDeletedSkilllistingCheck(true);
        setTimeout(() => {
          setDeletedSkilllistingCheck(false);
        }, 4000);
      } else {
        setplacebidModal(true);
      }
    } else {
      if (windowDimensions.width < 768) {
        history.push({
          pathname: "/login"
        });
      } else {
        dispatch(isModalVisibleAuth(true));
      }
    }
  };

  const handleAddToMatch = () => {
    history.push({ pathname: "/choose-gig",
      state: {
        skillListingIds: [+id]
      }
    });
  };

  useEffect(() => {
    if (userSKillListing?.bid?.length > 0) {
      setbidId(userSKillListing?.bid[userSKillListing?.bid?.length - 1]?.BidId);
      setBidDeclinedStatus(
      userSKillListing?.bid[userSKillListing?.bid?.length - 1]?.DeclineReason);

      dispatch(
      getConversationId(
      userSKillListing?.bid[userSKillListing?.bid?.length - 1]?.BidId));


    }
    // setAlreadyPlacedBid(userSKillListing?.bidStatus?.isPlacedBid)
    setAlreadyPlacedBid(false);
  }, [userSKillListing]);
  useEffect(() => {
    setFavorite(get_favorite);
  }, [get_favorite]);

  function removeEmployeeAssociation(employeeIdToRemove) {
    try {
      const updatedEmployeeAssociation = userProfile.EmployeeAssociation.filter(
      (id) => id != employeeIdToRemove);

      const UpdateData = {
        ...userProfile,
        EmployeeAssociation: updatedEmployeeAssociation
      };
      setuserProfileState(UpdateData);
      return UpdateData;
    } catch (error) {}
  }

  useEffect(() => {
    // if (favorite) {
    //   setColor("red");
    // } else {
    //   setColor("");
    // }
    if (get_favorite) {
      setColor("red");
    } else {
      setColor("");
    }
  }, [
  // favorite,
  get_favorite]);


  useEffect(() => {
    // here it is calling
    if (authTokenValue) {
      // if (Pdetails.skill_listings?.length > 0) {
      dispatch(
      getOneUserSkillListing({
        skillId: location.state?.id || location?.pathname?.split("profiledetail/")?.[1],
        jobId:
        location.state?.jobId ||
        location.search.split("jobId=")[1]?.split("&")[0]
      }));

      dispatch(getNotes({ id: location.state?.id || location?.pathname?.split("profiledetail/")?.[1] }));
    }
    // }
  }, [location.state, BidSuccess, InterviewSchedule]);

  const myfavourite = () => {
    if (authToken !== null && authToken !== "") {
      if (
      // !favorite
      get_favorite == false)
      {
        dispatch(postFavorites(Pdetails?.skill_listings?.[0]?.SkillListingId));
        dispatch(resetHeader());
        setFavorite(!favorite);
        // setDisplayModal(true);
      } else {
        dispatch(deleteFavorites(Pdetails?.skill_listings?.[0]?.SkillListingId));
        dispatch(resetHeader());
        setFavorite(!favorite);
        // setDisplayModal(true);
      }
    } else {
      if (windowDimensions.width > 768) {
        dispatch(isModalVisibleAuth(true));
      } else {
        history.push("/login");
      }
    }
  };
  useEffect(() => {
    if (favourite_status == "added" || favourite_status == "removed") {
      setDisplayModal(true);
    }
  }, [favourite_status]);

  useEffect(() => {
    setTimeout(() => {
      dispatch(clearRetractBid());
    }, 6000);
  }, [Retract]);

  const placeBidModalVisisblityHandler = (value) => {
    setplacebidModal(value);
  };
  var candidateList = [
  Pdetails?.skill_listings?.length > 0 && {
    id: Pdetails?.skill_listings?.[0]?.SkillListingId,
    AccountId:
    Pdetails?.skill_listings?.AccountId?.[0]?.Profiles?.Accounts?.AccountId,
    MobilePhone: Pdetails?.user_Schema?.Profiles?.MobilePhone,
    img: `${Pdetails?.user_Schema?.Profiles?.PictureUrl}`,
    AccountId: Pdetails?.skill_listings?.[0]?.Profiles?.Accounts?.AccountId,
    name: Pdetails?.user_Schema ?
    `${Pdetails.user_Schema.Profiles.FirstName} ${Pdetails.user_Schema.Profiles.LastName}` :
    "",
    experience: userSKillListing?.user_Schema?.Profiles?.ExperienceLevels?.
    ExperienceLevelName ?
    userSKillListing?.user_Schema?.Profiles?.ExperienceLevels?.
    ExperienceLevelName :
    "",
    title: Pdetails?.skill_listings?.[0]?.Title,
    desired_rate:
    !isNonHC(professionCode?.Professions?.ProfessionCode) ?
    Pdetails?.skill_listings?.[0]?.MinimumBid?.$numberDecimal ?
    Math.floor(
    Pdetails?.skill_listings?.[0]?.MinimumBid?.$numberDecimal) :

    Pdetails?.skill_listings?.[0]?.MinimumBid :
    Pdetails?.skill_listings?.[0]?.ClientRate?.$numberDecimal ?
    parseFloat(
    Pdetails?.skill_listings?.[0]?.ClientRate?.$numberDecimal)?.
    toFixed(2) :
    parseFloat(Pdetails?.skill_listings?.[0]?.ClientRate)?.toFixed(2),
    bidType: Pdetails?.skill_listings?.[0]?.BudgetTypes?.BudgetTypeName,
    profileType: Pdetails?.user_Schema?.Profiles?.ProfessionCode,
    GigType: Pdetails?.skill_listings?.[0]?.GigType,
    lastActive: Pdetails?.user_Schema?.LastLoginDate ?
    moment(Pdetails?.user_Schema?.LastLoginDate).fromNow() :
    "N/A"
  }];


  const messageCandidate = () => {
    if (authToken !== null && authToken !== "") {
      history.push({
        pathname: "/conversations",
        state: {
          openConvo: true,
          conversationId: msgsId.ConversationId
        }
      });
    } else {
      if (windowDimensions.width < 768) {
        history.push({
          pathname: "/login"
        });
      } else {
        dispatch(isModalVisibleAuth(true));
      }
    }
  };

  const msgtxt = (html) => {
    var cache = {},
      character,
      e = document.createElement("div");
    return html?.replace(/([&][^&; ]+[;])/g, function (entity) {
      character = cache[entity];
      if (!character) {
        e.innerHTML = entity;
        if (e.childNodes[0])
        character = cache[entity] = e.childNodes[0].nodeValue;else
        character = "";
      }
      return character;
    });
  };

  const scheduleInterview = () => {
    window.scrollTo(0, 0);
    if (authToken !== null && authToken !== "") {
      setinterviewDrawer(true);
    } else {
      if (windowDimensions.width < 768) {
        history.push({
          pathname: "/login"
        });
      } else {
        dispatch(isModalVisibleAuth(true));
      }
    }
  };

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

  useEffect(() => {
    if (Pdetails?.user_Schema?.hired == true) {
      setMarginVal("35%");
    } else {
      setMarginVal("0%");
    }
  }, [userSKillListing?.status]);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handle_3d_resume_btn = () => {
    try {if (authToken == null || authToken == "") {
        dispatch(isModalVisibleAuth(true));
      } else {
        history.push({
          pathname: "/resume-3d",
          state: {
            candidateid: Pdetails?.user_Schema.AccountId,
            candidateBidinfo: userSKillListing?.bid,
            hired: Pdetails?.user_Schema?.hired == true ? true : false
          }
        });
      }} catch {}
  };

  useEffect(async () => {
    dispatch(clearUpdateBidSuccess());
    if (authTokenValue) {
      if (location.state?.id || id) {
        var headers = {
          "Content-Type": "application/json",
          Authorization: authToken
        };
        await axios.post(
        `${BackendApiBaseUrl}/empprofile/views/skilllisting`,
        { SkillListingId: location.state?.id ?? id },
        { headers });

      }
    }
  }, [location.state?.id, id]);

  function getItem(label, value, key, icon, children, type) {
    return {
      value,
      icon,
      key,
      children,
      label,
      type
    };
  }

  const details = [
  getItem("Skill listing", "Skill Listing", "Skill Listing"),
  getItem("Work history", "Work History", "Work History"),
  isHC(Pdetails?.user_Schema?.Professions?.ProfessionCode) ?
  getItem("Credentialing", "Credentialing", "Credentialing") :
  getItem(
  "Certifications & awards",
  "Certifications & Awards",
  "Certifications & Awards"),

  getItem("Education history", "Education History", "Education History"),
  getItem("Add note", "Add Note", "Add Note")];

  const handleMenuClick = (e) => {
    if (e.key === "Skill Listing" || e === "Skill Listing") {
      setMenuClicked("Skill Listing");
    } else if (e.key === "Reviews" || e === "Reviews") {
      authToken != null && authToken !== "" ?
      setMenuClicked("Reviews") :
      dispatch(isModalVisibleAuth(true));
    } else if (e.key === "Education History" || e === "Education History") {
      authToken != null && authToken !== "" ?
      setMenuClicked("Education History") :
      dispatch(isModalVisibleAuth(true));
    } else if (e.key === "Work History" || e === "Work History") {
      authToken != null && authToken !== "" ?
      setMenuClicked("Work History") :
      dispatch(isModalVisibleAuth(true));
    } else if (e.key === "Add Note" || e === "Add Note") {
      authToken != null && authToken !== "" ?
      setMenuClicked("Add Note") :
      dispatch(isModalVisibleAuth(true));
    } else if (e.key === "Credentialing" || e === "Credentialing") {
      authToken != null && authToken !== "" ?
      setMenuClicked("Credentialing") :
      dispatch(isModalVisibleAuth(true));
    } else if (
    e.key === "Certifications & Awards" ||
    e === "Certifications & Awards")
    {
      authToken != null && authToken !== "" ?
      setMenuClicked("Certifications & Awards") :
      dispatch(isModalVisibleAuth(true));
    }
  };

  function removePvtTalent() {
    setShowConfirmationModal(!showConfirmationModal);
  }

  useEffect(() => {
    if (removePvtResponse) {
      localStorage.setItem(
      "userProfile",
      JSON.stringify(
      removeEmployeeAssociation(
      Pdetails?.skill_listings?.[0]?.Profiles?.Accounts?.AccountId)));



    }
  }, [removePvtResponse]);

  const downloadResume = async () => {
    const resumeURL =
    Pdetails?.user_Schema?.Profiles?.TalentDocuments?.filter((doc) =>
    doc.CredentialDocument.CredentialDocumentName.includes("Resume"));


    if (authToken == null || authToken == "") {
      dispatch(isModalVisibleAuth(true));
    } else {
      try {
        if (resumeURL) {
          window.open(
          `${process.env.REACT_APP_S3_URL}${
          resumeURL[0].DocumentUrl.charAt(0) !== "/" ? "/" : ""
          }${resumeURL[0].DocumentUrl}`);

        }
      } catch (error) {}
    }
  };

  const NegbidStatues = {
    26: "Offer Declined",
    8: "Canceled",
    18: "Off Billing",
    23: "Interview Cancelled",
    3: "Declined",
    22: "Terminated",
    14: "Interview Declined",
    21: "Terminated"

  };
  const { Profiles } = Pdetails?.user_Schema || {};
  const { states = [], isCompact } = Profiles || {};
  const formattedStates = states.join(", ");
  const displayStates = `${isCompact === 'true' ? '(Compact), ' : ''}${formattedStates}`;

  const interviewStatuses = [6, 23, 7, 14]; //interview, Interview Cancelled, Interview Accepted, Interview Declined
  return (
    <>
      <InterviewDrawer
      bid={bidId}
      open={interviewDrawer}
      close={setinterviewDrawer}
      bidType={1}
      setInterviewSchedule={setInterviewSchedule} />
      
      {
      // location.state?.id !== userSKillListing?.skill_listings?.SkillListingId
      loading || skillloading ?
      <Loader /> :

      <div className="profile-outermost-container">
            {displayModal ?
        <>
                {favourite_status == "added" && get_favorite == true ?
          <TopAlert
          display={favourite_status == "added"}
          title={"Skill listing added to favorites"}
          type={"success"} /> :

          null}

                {favourite_status == "removed" && get_favorite == false ?
          <TopAlert
          display={favourite_status == "removed"}
          title={"Skill listing removed from favorites"}
          type={"success"} /> :

          null}
              </> :

        <></>}
        
            {Retract && Retract !== "FromMsg" &&
        <TopAlert
        display={"flex"}
        title={"Your bid retracted Successfully"}
        type="success" />}

        
            {deletedSkilllistingCheck &&
        <TopAlert
        display={"flex"}
        title={"Skilllisting you're trying to bid is deleted"}
        type="warning" />}

        
            {error ?
        <TopAlert
        display={"flex"}
        title={"Cannot create PDF for doc files"}
        type="warning" /> :

        null}

          {placebidModal && <PlaceBidModal
        fromMatches={location.state?.fromMatches}
        visible={placebidModal}
        placeBidModalVisisblityHandler={placeBidModalVisisblityHandler}
        selectedCandidates={candidateList}
        desired_rate={
        Pdetails?.skill_listings?.length > 0 && (
        Pdetails?.skill_listings?.[0]?.MinimumBid?.$numberDecimal ?
        Math.floor(
        Pdetails?.skill_listings?.[0]?.MinimumBid?.$numberDecimal) :

        Pdetails?.skill_listings?.[0]?.MinimumBid)}

        multiBid={false}
        rate_flag={true}
        frompdetail={true}
        fromDetailPage={true}
        jobId={location.state?.jobId}
        jobdetails={location.state?.jobdetails}
        userSKillListing={userSKillListing}
        setHidePagePvt={setHidePagePvt}
        HidePagePvt={HidePagePvt} />}

        
            {!HidePagePvt ?
        <div className="profile-reviews-row">
                <div>
                  {showBackButton &&
            <p
            onClick={handleBack}
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              textAlign: "center",
              marginBottom: "0.2rem"
            }}>
              
                      <img
              src={backButton}
              alt="back-button"
              style={{
                paddingLeft: "10px",
                width: "20px",
                height: "20px",
                marginTop: "16px"
              }} />
              
                      <span
              style={{
                color: "#4054B2",
                paddingLeft: "10px",
                marginTop: "16px"
              }}>
                
                        back
                      </span>
                    </p>}
            
                  <div className="profile-skillListing-card">
                    <div className="profile-part">
                      {loading || skillloading ?
                <div>
                          <Skeleton avatar active />
                        </div> :
                windowDimensions.width < 768 ?
                <Comment
                avatar={
                <Col>
                              <div className="top-rated-image">
                                {/* <img className="top-rated-img" src={Frame} /> */}
                              </div>
                              <Col
                  className="img-container"
                  style={{ marginLeft: `${marginVal}` }}>
                    
                                {Pdetails?.user_Schema ?
                    Pdetails.user_Schema?.Profiles.PictureUrl &&
                    Pdetails?.user_Schema?.Profiles?.PictureUrl?.split(
                    "/")?.
                    pop() !== "no-pic.png" ?
                    <img
                    className="profile-image"
                    alt="example"
                    // src={profilePic && profilePic}
                    src={`${process.env.REACT_APP_S3_URL}${
                    Pdetails?.user_Schema?.Profiles?.PictureUrl?.charAt(
                    0) !==
                    "/" ?
                    "/" :
                    ""
                    }${
                    Pdetails?.user_Schema?.Profiles?.
                    PictureUrl
                    }`}
                    onError={() => {
                      setImageError(true);
                    }} /> :


                    <div className="img-text">
                                      {Pdetails?.user_Schema?.Profiles?.
                      FirstName ?
                      Pdetails?.user_Schema?.Profiles?.FirstName.split(
                      "")[
                      0].
                      charAt(0).
                      toUpperCase() :
                      "C"}
                                    </div> :

                    null}
                              </Col>
                            </Col>}

                content={
                <div>
                              <div
                  className={
                  authToken !== null && authToken !== "" ?
                  "username Private-Market-log-mobile" :
                  "Profile-detail-blurName"}>

                    
                                {Pdetails?.user_Schema?.Profiles?.FirstName !=
                    null ?
                    `${Pdetails.user_Schema.Profiles.FirstName} ${Pdetails.user_Schema.Profiles.LastName}` :
                    Pdetails.user_Schema?.UserName ??
                    "Candidate name"}
                                <div className="Pvt-mobile-log-section">
                                  {
                      userProfileState?.EmployeeAssociation?.includes(
                      Pdetails?.skill_listings ?
                      Pdetails?.skill_listings?.[0]?.Profiles?.
                      Accounts?.AccountId :
                      null) ?

                      <PrivateTagSkillListing
                      tooltipPlacement={"bottomRight"} /> :

                      null}
                                  {favLoading ?
                      <div
                      style={{
                        float: "right",
                        color: "#118936",
                        marginTop: "3px"
                      }}>
                        
                                      <LoadingOutlined />
                                    </div> :

                      <HeartFilled
                      style={{
                        float: "right",
                        opacity: "65%",
                        color: color,
                        marginTop: "3px"
                      }}
                      onClick={myfavourite} />}

                      
                                </div>
                              </div>
                              <Row style={{ marginTop: "3px" }}>
                                <div>
                                  <Rate
                      value={stars}
                      allowHalf
                      disabled
                      className="profile-ratings" />
                      
                                </div>
                                <div lg={11} sm={11} xs={9}>
                                  <div
                      style={{
                        color: "#7e7e7e",
                        fontSize: "12px",
                        paddingTop: "1px"
                      }}>
                        
                                    {stars}

                                    {Pdetails?.user_Schema?.Profiles?.Review !==
                        0 &&
                        Pdetails?.user_Schema?.Profiles?.
                        Review !== null &&
                        Pdetails?.user_Schema?.Profiles?.
                        Review !== undefined &&
                        "(" +
                        Pdetails?.user_Schema?.Profiles?.
                        Review +
                        " Review)"}
                                  </div>
                                </div>
                              </Row>

                              <div className="candidate-experience-mobile">
                                <img
                    className="experience-icon"
                    src={ExpIcon}
                    alt={"experience-icon"}
                    style={{
                      width: "29px",
                      height: "18.5px",

                      marginTop: "1px"
                    }} />
                    
                                <span className="experience_level">
                                  {userSKillListing?.user_Schema?.Profiles?.
                      ExperienceLevels?.ExperienceLevelName ?
                      `${userSKillListing?.user_Schema?.Profiles?.ExperienceLevels?.ExperienceLevelName}    ` :
                      Pdetails?.user_Schema?.Profiles.
                      ExperienceLevels?.ExperienceLevelName ?
                      `${Pdetails.user_Schema?.Profiles.ExperienceLevels?.ExperienceLevelName}   ` :
                      "N/A"}
                                </span>
                              </div>
                              {isHC(userProfile?.Professions?.ProfessionCode) &&
                  states?.length > 0 ?
                  <>
                                <img
                    src={stateLicense}
                    alt="license"
                    style={{ marginBottom: "2px" }} />
                    
                                {displayStates}
                              </> :
                  <></>
                  // <div
                  //   style={{
                  //     marginLeft: "1.5%",
                  //     whiteSpace: "nowrap",
                  //     textOverflow: "ellipsis",
                  //     display: "flex",
                  //     marginTop: "0.5rem",
                  //     justifyContent: "center",
                  //   }}
                  // >
                  //   <TfiLocationPin
                  //     className="experience-icon2x"
                  //     style={{ margin: "1px 2px 0 0" }}
                  //   />
                  //   {Pdetails?.user_Schema?.Profiles?.Location
                  //     ?.LocationWithCountry ? (
                  //     <Tooltip
                  //       title={
                  //         Pdetails?.user_Schema?.Profiles?.Location
                  //           ?.LocationWithCountry
                  //       }
                  //     >
                  //       <div className="Job-TitleP">
                  //         {
                  //           Pdetails?.user_Schema?.Profiles
                  //             ?.Location?.LocationWithCountry
                  //         }
                  //       </div>
                  //     </Tooltip>
                  //   ) : (
                  //     "N/A"
                  //   )}
                  // </div>
                  }
                              {/* <div className="candidate-workAuthM">
                    {Pdetails?.user_Schema?.Profiles?.VisaStatuses
                    ?.VisaStatusCode ? (
                    <div
                    style={{
                    display: "contents",
                    whiteSpace: "nowrap",
                    }}
                    >
                    <Tooltip
                    title="Work authorization"
                    placement="top"
                    >
                    <FiUserCheck
                    style={{
                    color: "#5e5e5e",
                    margin: "1% 3% 2% 0",
                    fontSize: "19px",
                    }}
                    />
                    </Tooltip>
                    {
                    Pdetails?.user_Schema?.Profiles
                    ?.VisaStatuses?.VisaStatusName
                    }
                    </div>
                    ) : (
                    <div
                    style={{
                    display: "contents",
                    whiteSpace: "nowrap",
                    }}
                    >
                    <FiUserCheck
                    style={{
                    color: "#5e5e5e",
                    margin: "1% 3% 2% 0",
                    fontSize: "19px",
                    }}
                    />
                    N/A
                    </div>
                    )}
                    {Pdetails?.user_Schema?.Profiles
                    ?.BackgroundCheck ? (
                    <div className="candidate-license-main">
                    <img
                    className="citizen-icon2x"
                    src={citizen}
                    alt={"experience-icon"}
                    />
                    {
                    Pdetails?.user_Schema?.Profiles
                    ?.BackgroundCheck
                    }
                    </div>
                    ) : null}
                    </div> */}

                              {/* //email for hc user */}
                              {(userSKillListing?.bid?.length > 0 ||
                  Pdetails?.user_Schema?.hired == true) && isHC(
                  userProfile?.Professions?.ProfessionCode) &&

                  Pdetails?.user_Schema?.EmailAddress &&
                  Pdetails?.user_Schema?.EmailAddress != null &&
                  Pdetails?.user_Schema?.EmailAddress !=
                  undefined ?
                  <EmailCard emailAddress={Pdetails?.user_Schema?.EmailAddress}>
                                <div
                    className={"last-active"}
                    style={{ color: "#4D60B7" }}>
                      
                                  <AiOutlineMail className="email-icon" />
                                  {Pdetails?.user_Schema?.EmailAddress}
                                </div>
                                </EmailCard> :
                  null}

                              {/* email for it */}
                              {(userSKillListing?.bid?.length > 0 ||
                  location.state?.searchType == "Email" ||
                  Pdetails?.user_Schema?.hired == true) &&
                  Pdetails?.user_Schema?.EmailAddress &&
                  <EmailCard emailAddress={Pdetails?.user_Schema?.EmailAddress}>
                                  <div
                    className={"last-active"}
                    style={{ color: "#4D60B7" }}>
                      
                                    <AiOutlineMail className="email-icon" />
                                    {Pdetails?.user_Schema?.EmailAddress}
                                  </div>
                                  </EmailCard>}
                  

                              {(userSKillListing?.bid?.length > 0 ||
                  Pdetails?.user_Schema?.hired == true) &&
                  Pdetails?.user_Schema?.Profiles?.
                  MobilePhone &&
                  <div className="candidate-phoneno">
                                    <BsTelephone className="phone-icon" />
                                    {formatPhoneNumber(
                    Pdetails?.user_Schema?.Profiles?.
                    MobilePhone)}
                    
                                  </div>}
                  
                              {Pdetails?.user_Schema?.hired ?
                  <div className="candidate-phoneno">
                                  <img src={SSN} className="phone-icon" />
                                  {Pdetails?.user_Schema?.SSN ?
                    Pdetails.user_Schema.SSN :
                    "N/A"}
                                </div> :
                  null}
                              {/* //email */}
                              {/* {location.state?.searchType == "Email" && location.state?.email ? (
                    <div className={"last-active"}>
                    {location.state?.email &&
                    location.state?.email != null
                    ? location.state?.email
                    : "Email Address"}
                    </div>
                    ): null} */}

                              {Pdetails?.user_Schema?.LastLoginDate &&
                  <div className={"last-active"}>
                                  {Pdetails?.user_Schema &&
                    Pdetails?.user_Schema?.LastLoginDate != null ?
                    "Last active " +
                    moment(
                    Pdetails?.user_Schema?.LastLoginDate).
                    fromNow() :
                    "Last active: not available"}
                                </div>}
                  

                              {isInvited &&
                  <EmailCard emailAddress={Pdetails?.skill_listings?.[0]?.Profiles?.Accounts?.EmailAddress}>
                                 <div>
                                  <img src={Invitedemail} alt="Invited" />
                                  {Pdetails?.skill_listings?.[0]?.Profiles?.
                      Accounts?.EmailAddress || "N/A"}
                                 </div>
                                </EmailCard>}
                  
                              {isInvited &&
                  <div>
                                  <img
                    src={invitedNumber}
                    alt="Invited Number" />
                    
                                  {formatPhoneNumber(
                    Pdetails?.user_Schema?.Profiles?.MobilePhone)}
                    
                                </div>}
                  

                              {isInvited ?
                  <div className="InvitationText">
                                  <div style={{ color: "#DB2828" }}>
                                    Invitation not accepted
                                    <Tooltip
                      title={
                      <div>
                                          <strong>Info</strong>
                                          <div
                        style={{
                          borderBottom: "1px solid grey"
                        }}>
                        </div>
                                          <div>
                                            Invite sent by{" "}
                                            <strong>{employerName}</strong> from{" "}
                                            <br />
                                            {employerEmail} on{" "}
                                            {formatDate(inviteDate) || "N/A"}
                                          </div>
                                        </div>}

                      placement="bottom">
                        
                                      {/* <InfoCircleOutlined
                          style={{
                          color: "#7E7E7E",
                          fontSize: "10px",
                          marginLeft: "10px",
                          }}
                          /> */}
                                      <img
                        src={InfoIcon}
                        alt=""
                        style={{ marginLeft: "10px" }} />
                        
                                    </Tooltip>
                                  </div>
                                </div> :

                  ""}
                  

                              {Pdetails?.user_Schema?.hired == true ?
                  <div>
                                  <Tag className="status-tag">Hired</Tag>
                                </div> :
                  null}
                              <Row
                  style={{
                    width: "100%",
                    paddingTop: "13px",
                    textAlign: "center"
                  }}>
                    
                                <Col>
                                  <button
                      className="resume-btn resume-btn-3d-text"
                      onClick={handle_3d_resume_btn}
                      disabled={isInvited}>
                        
                                    <img src={threeDicon} alt="" className="resume-3d-icon" />
                                    View 3D resume
                                  </button>
                                </Col>
                              </Row>
                              {skillloading ?
                  <></> :
                  resumeCheck?.length > 0 &&
                  userSKillListing?.status !== "idle" &&
                  showResumeButton ?
                  <button
                  className="resume-btn"
                  onClick={() => downloadResume()}>
                    
                                  &nbsp;
                                  {/* <img src={threeDicon} className="resume-3d-icon" /> */}
                                  <DownloadOutlined
                    // className={'download-icon'}
                    // className={"resume-3d-icon"}
                    />
                                  &nbsp; Download resume
                                </button> :
                  null}
                            </div>} /> :



                <>
                          {/* for desktop */}
                          <div className="desktop-profile-card">
                            {favLoading ?
                    <div
                    style={{
                      fontSize: "16px",
                      marginTop: "12px",
                      position: "absolute",
                      margin: "1% 0% 0% 1%",
                      color: "#118936"
                    }}>
                      
                                <LoadingOutlined />
                              </div> :

                    <HeartFilled
                    style={{
                      opacity: "65%",
                      color: color,
                      fontSize: "16px",
                      marginTop: "12px",
                      position: "absolute",
                      margin: "1% 0% 0% 1%"
                    }}
                    onClick={myfavourite} />}

                    
                            {/* {
                      userProfile?.IsPrivateEmployer===true? <PrivateTagSkillListing/>
                      :""
                      } */}
                            <div className="private-market-skillDetail">
                              {
                      userProfileState?.EmployeeAssociation?.includes(
                      Pdetails?.skill_listings ?
                      Pdetails?.skill_listings?.[0]?.Profiles?.
                      Accounts?.AccountId :
                      null) &&

                      userProfile?.IsPrivateEmployer === true ?
                      <PrivateTagSkillListing /> :
                      null}
                            </div>
                            <div style={{ margin: "auto", direction: "rtl" }}>
                              <div className="top-rated-image">
                                {/* <img className="top-rated-img" src={Frame2x} /> */}
                              </div>
                              <Col
                      className="img-container"
                      // style={{ marginLeft: `${marginVal}` }}
                      >
                                {Pdetails?.user_Schema?.Profiles?.PictureUrl &&
                        !imageError &&
                        Pdetails?.user_Schema?.Profiles?.PictureUrl?.split(
                        "/")?.
                        pop() !== "no-pic.png" ?
                        <img
                        className="profile-image"
                        alt="example"
                        // src={profilePic && profilePic}
                        src={`${process.env.REACT_APP_S3_URL}${
                        Pdetails?.user_Schema?.Profiles?.PictureUrl?.charAt(
                        0) !==
                        "/" ?
                        "/" :
                        ""
                        }${
                        Pdetails?.user_Schema?.Profiles?.
                        PictureUrl
                        }`}
                        onError={() => {
                          setImageError(true);
                        }} /> :


                        <div className="img-text">
                                    {Pdetails?.user_Schema?.Profiles?.FirstName ?
                          Pdetails?.user_Schema?.Profiles?.FirstName.split(
                          "")[
                          0].
                          charAt(0).
                          toUpperCase() :
                          "C"}
                                  </div>}
                        
                                {/* ) : null} */}
                              </Col>
                            </div>
                            {Pdetails?.user_Schema?.hired == true ?
                    <div className="status-tag-div">
                                <Tag
                      className="status-tag"
                      style={{ position: "absolute" }}>
                        
                                  Hired
                                </Tag>
                              </div> :
                    null}
                          </div>

                          <div className="profile-details-container">
                            <div
                    className={
                    authToken !== null && authToken !== "" ?
                    "username" :
                    "blurName"}>

                      
                              {Pdetails?.user_Schema?.Profiles?.FirstName != null ?
                      `${Pdetails?.user_Schema?.Profiles.FirstName} ${Pdetails?.user_Schema?.Profiles?.LastName}` :
                      Pdetails?.user_Schema?.UserName ??
                      "Candidate name"}
                            </div>
                            <div
                    className="rating-div"
                    style={{
                      marginTop:
                      location.state?.email ||
                      Pdetails?.user_Schema?.EmailAddress ?
                      "0.5rem" :
                      "0rem"
                    }}>
                      
                              <div>
                                <Rate
                        value={stars}
                        allowHalf
                        disabled
                        defaultValue={DefaultRating}
                        className="profile-ratings" />
                        
                              </div>
                              <div
                      style={{
                        color: "#7e7e7e",
                        fontSize: "12px",
                        paddingTop: "1px"
                      }}>
                        
                                {stars}

                                {Pdetails?.user_Schema?.Profiles?.Review !==
                        0 &&
                        Pdetails?.user_Schema?.Profiles?.Review !==
                        null &&
                        Pdetails?.user_Schema?.Profiles?.Review !==
                        undefined &&
                        "(" +
                        Pdetails?.user_Schema?.Profiles?.Review +
                        " Review)"}
                              </div>
                            </div>
                            <div className="candidate-experience">
                              <div className="experience-location-container">
                                <div
                        style={{
                          // marginLeft: "1.5%",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          display: "flex",

                          justifyContent: "center"

                          // width: '20px',
                        }}>
                          
                                  {/* <img
                            className="experience-icon2x"
                            src={ps_suitcase2x}
                            alt={"experience-icon"}
                            /> */}
                                  <img
                          className="experience-icon2x"
                          src={ExpIcon}
                          alt={"experience-icon"}
                          style={{
                            width: "16px",
                            height: "16px",
                            marginTop: "2.5px",
                            marginRight: "4px"
                          }} />
                          
                                  <span>
                                    {" "}
                                    {Pdetails?.user_Schema?.Profiles.
                            ExperienceLevels?.ExperienceLevelName &&
                            Pdetails?.user_Schema?.Profiles.
                            ExperienceLevels?.ExperienceLevelName !=
                            null &&
                            Pdetails?.user_Schema?.Profiles.
                            ExperienceLevels?.ExperienceLevelName !=
                            "" &&
                            Pdetails?.user_Schema?.Profiles.
                            ExperienceLevels?.ExperienceLevelName !=
                            undefined ?
                            Pdetails?.user_Schema?.Profiles.
                            ExperienceLevels?.
                            ExperienceLevelName +
                            " of experience" :
                            "N/A"}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {isHC(userProfile?.Professions?.ProfessionCode) &&
                    states?.length > 0 ?
                    <>
                                <img
                      src={stateLicense}
                      alt="license"
                      style={{ marginBottom: "2px" }} />
                      
                                {displayStates}
                              </> :
                    <></>
                    // <div
                    //   style={{
                    //     marginLeft: "1.5%",
                    //     whiteSpace: "nowrap",
                    //     textOverflow: "ellipsis",
                    //     display: "flex",
                    //     marginTop: "0.5rem",
                    //     justifyContent: "center",
                    //   }}
                    // >
                    //   <TfiLocationPin
                    //     className="experience-icon2x"
                    //     style={{ margin: "1px 2px 0 0" }}
                    //   />
                    //   {Pdetails?.user_Schema?.Profiles?.Location
                    //     ?.LocationWithCountry ? (
                    //     <Tooltip
                    //       title={
                    //         Pdetails?.user_Schema?.Profiles?.Location
                    //           ?.LocationWithCountry
                    //       }
                    //     >
                    //       <div className="Job-TitleP">
                    //         {
                    //           Pdetails?.user_Schema?.Profiles
                    //             ?.Location?.LocationWithCountry
                    //         }
                    //       </div>
                    //     </Tooltip>
                    //   ) : (
                    //     "N/A"
                    //   )}
                    // </div>
                    }
                            </div>
                            {(userSKillListing?.bid?.length > 0 ||
                  Pdetails?.user_Schema?.hired == true) && isHC(
                  userProfile?.Professions?.ProfessionCode) &&
                  Pdetails?.user_Schema?.EmailAddress &&
                  Pdetails?.user_Schema?.EmailAddress != null &&
                  Pdetails?.user_Schema?.EmailAddress != undefined ?
                  <EmailCard emailAddress={Pdetails?.user_Schema?.EmailAddress}>

                              <div
                    className={"last-active"}
                    style={{ color: "#4D60B7", textAlign: 'center', cursor: 'pointer' }}>
                      
                                <AiOutlineMail className="email-icon" />
                                {Pdetails?.user_Schema?.EmailAddress}
                              </div>
                                </EmailCard> :
                  null}

                            {(userSKillListing?.bid?.length > 0 ||
                  location.state?.searchType == "Email" ||
                  isNonHC(userProfile?.Professions?.ProfessionCode) &&

                  userProfileState?.EmployeeAssociation?.includes(
                  Pdetails?.skill_listings ?
                  Pdetails?.skill_listings?.[0]?.Profiles?.
                  Accounts?.AccountId :
                  null) &&

                  userProfile?.IsPrivateEmployer === true) && (
                  Pdetails?.user_Schema?.hired == true ||
                  userProfile?.IsPrivateEmployer) && isNonHC(
                  userProfile?.Professions?.ProfessionCode) &&
                  Pdetails?.user_Schema?.EmailAddress &&
                  Pdetails?.user_Schema?.EmailAddress != null &&
                  Pdetails?.user_Schema?.EmailAddress != undefined ?
                  <EmailCard emailAddress={Pdetails?.user_Schema?.EmailAddress}>

                              <div
                    className={"last-active"}
                    style={{ color: "#4D60B7", textAlign: 'center' }}>
                      
                                <AiOutlineMail className="email-icon" />
                                {Pdetails?.user_Schema?.EmailAddress}
                              </div>
                                </EmailCard> :
                  null}

                            {(userSKillListing?.bid?.length > 0 ||
                  isNonHC(userProfile?.Professions?.ProfessionCode) &&

                  userProfileState?.EmployeeAssociation?.includes(
                  Pdetails?.skill_listings ?
                  Pdetails?.skill_listings?.[0]?.Profiles?.
                  Accounts?.AccountId :
                  null) &&

                  userProfile?.IsPrivateEmployer === true) && (
                  Pdetails?.user_Schema?.hired == true ||
                  userProfile?.IsPrivateEmployer) &&
                  Pdetails?.user_Schema?.Profiles?.MobilePhone &&
                  <div className="candidate-phoneno">
                                  <BsTelephone className="phone-icon" />
                                  {formatPhoneNumber(
                    Pdetails?.user_Schema?.Profiles?.MobilePhone)}
                    
                                </div>}
                  
                            {Pdetails?.user_Schema?.hired ?
                  <div className="candidate-phoneno">
                                <img src={SSN} className="phone-icon" />
                                {Pdetails?.user_Schema?.SSN ?
                    Pdetails.user_Schema.SSN :
                    "N/A"}
                              </div> :
                  null}
                            {Pdetails?.user_Schema?.LastLoginDate &&
                  <div className={"last-active"}>
                                {
                    Pdetails?.user_Schema &&
                    Pdetails.user_Schema?.LastLoginDate !=
                    null &&
                    "Last active " +
                    moment(
                    Pdetails.user_Schema.LastLoginDate).
                    fromNow()
                    // : "Last active : N/A"
                    }
                              </div>}
                  

                            {isInvited &&
                  <EmailCard emailAddress={Pdetails?.skill_listings?.[0]?.Profiles?.
                  Accounts?.EmailAddress}> 
                              <div
                    style={{
                      color: "#4054B2",
                      paddingRight: "3px",
                      textAlign: 'center'
                    }}>
                      
                                <span style={{ paddingRight: "10px" }}>
                                  <img src={Invitedemail} alt="Invited" />
                                </span>
                                {Pdetails?.skill_listings?.[0]?.Profiles?.
                      Accounts?.EmailAddress || "N/A"}
                              </div>
                              </EmailCard>}
                  

                            {isInvited &&
                  <div style={{ textAlign: 'center' }}>
                                <span
                    style={{
                      paddingRight: "8px",
                      paddingTop: "10px"
                    }}>
                      
                                  {" "}
                                  <img
                      src={invitedNumber}
                      alt="Invited Number" />
                      
                                </span>

                                {formatPhoneNumber(
                    Pdetails?.user_Schema?.Profiles?.MobilePhone)}
                    
                              </div>}
                  

                            {isInvited ?
                  <div className="InvitationText">
                                <div
                    style={{
                      color: "#DB2828",
                      paddingTop: "10px"
                    }}>
                      
                                  Invitation not accepted
                                  <Tooltip
                      title={
                      <div>
                                        <strong>Info</strong>
                                        <div
                        style={{
                          borderBottom: "1px solid grey"
                        }}>
                        </div>
                                        <div>
                                          Invite sent by{" "}
                                          <strong>{employerName}</strong> from{" "}
                                          <br />
                                          {employerEmail} on{" "}
                                          {formatDate(inviteDate) || "N/A"}
                                        </div>
                                      </div>}

                      placement="bottom">
                        
                                    {/* <InfoCircleOutlined
                          style={{
                          color: "#7E7E7E",
                          fontSize: "10px",
                          marginLeft: "10px",
                          }}
                          /> */}
                                    <img
                        src={InfoIcon}
                        alt=""
                        style={{ marginLeft: "10px" }} />
                        
                                  </Tooltip>
                                </div>
                              </div> :

                  ""}
                  

                            {Pdetails?.user_Schema?.Profiles?.ProfileSocialMedia?.
                  length > 0 ?
                  <div className="candidate-social-icons-main">
                                {Pdetails?.user_Schema?.Profiles?.
                    ProfileSocialMedia?.length > 0 &&
                    Pdetails?.user_Schema?.Profiles?.ProfileSocialMedia.map(
                    (item) => {
                      return item?.SocialMediaType?.
                      SocialMediaTypeCode === "LI" ?
                      <a
                      href={
                      item?.SocialMediaType?.
                      SocialMediaTypeURL +
                      item?.SocialMediaTypeSlug}

                      target="_blank"
                      className="candidate-social-icon">
                        
                                          <BsLinkedin />
                                        </a> :
                      item?.SocialMediaType?.
                      SocialMediaTypeCode === "FB" ?
                      <a
                      href={
                      item?.SocialMediaType?.
                      SocialMediaTypeURL +
                      item?.SocialMediaTypeSlug}

                      target="_blank"
                      className="candidate-social-icon">
                        
                                          <BsFacebook />
                                        </a> :
                      item?.SocialMediaType?.
                      SocialMediaTypeCode === "GH" ?
                      <a
                      href={
                      item?.SocialMediaType?.
                      SocialMediaTypeURL +
                      item?.SocialMediaTypeSlug}

                      target="_blank"
                      className="candidate-social-icon">
                        
                                          <GrGithub />
                                        </a> :
                      item?.SocialMediaType?.
                      SocialMediaTypeCode === "SO" ?
                      <a
                      href={
                      item?.SocialMediaType?.
                      SocialMediaTypeURL +
                      item?.SocialMediaTypeSlug}

                      target="_blank"
                      className="candidate-social-icon">
                        
                                          <BsStackOverflow />
                                        </a> :
                      null;
                    })}
                    
                              </div> :
                  null}
                            <button
                  className="resume-btn-3d"
                  onClick={handle_3d_resume_btn}
                  disabled={isInvited}>
                    
                              <img
                    src={threeDicon}
                    className="resume-3d-icon" />
                    
                              View 3D resumes
                            </button>
                            {skillloading ?
                  <></> :
                  resumeCheck?.length > 0 &&
                  userSKillListing?.isPlacedBidByTalentOrEmployer ==
                  true &&
                  showResumeButton ?
                  <div style={{ textAlign: "center" }}>
                                <button
                    className="dn-resume-btn-3d"
                    onClick={() => downloadResume()}>
                      
                                  {/* <img src={threeDicon} className="resume-3d-icon" /> */}
                                  <DownloadOutlined
                      // className={'download-icon'}
                      className={"resume-3d-icon"} />
                      
                                  Download resume
                                </button>
                              </div> :
                  null}
                        </>}
                
                    </div>
                  </div>

                  {windowDimensions.width > 769 &&
            <div className="candidate-details-menu">
                      <Menu
              defaultSelectedKeys={"Skill Listing"}
              onClick={handleMenuClick}
              style={{
                width: "100%",
                paddingTop: "5px"
              }}
              mode="inline"
              items={details} />
              
                    </div>}
            
                </div>

                {windowDimensions.width <= 769 &&
          <Row
          className="details-buttons-container"
          style={{
            // textAlign: "center",
            width: "100%",
            height: "max-content"
          }}>
            
                    {skillloading ?
            <div style={{ width: "90%", margin: "auto" }}>
                        <Skeleton active />
                      </div> :
            isInvited ?
            <HiredStatusbtns
            chaticon={cil_chat_bubble}
            disChatIcon={cil_chat_bubble_faded}
            messageCandidate={messageCandidate}
            isInvited={isInvited} /> :

            !RetractSuccess &&
            userSKillListing?.bid?.length > 0 &&
            !bidDeclinedStatus &&
            !!!NegbidStatues[
            userSKillListing?.bid?.length > 0 &&
            userSKillListing?.bid[
            userSKillListing?.bid?.length - 1]?.
            BidStatusId] &&

            Pdetails?.user_Schema?.hired != true ?
            <>
                        <PlacedBidBtns
              jobId={location.state?.jobId}
              jobdetails={location.state?.jobdetails}
              fromMatches={location.state?.fromMatches}
              userSkillData={userSKillListing}
              skil_id={location.state?.id}
              HidePagePvt={HidePagePvt}
              setHidePagePvt={setHidePagePvt}
              disableDownloadButton={disableDownloadButton} />
              
                        <Col lg={24} xs={24}>
                          <button
                disabled={
                userSKillListing?.bid?.length > 0 &&
                interviewStatuses.includes(
                userSKillListing?.bid[
                userSKillListing?.bid?.length - 1]?.
                BidStatusId)}


                className={
                userSKillListing?.bid?.length > 0 &&
                !!interviewStatuses.includes(
                userSKillListing?.bid[
                userSKillListing?.bid?.length - 1]?.
                BidStatusId) ||

                RetractSuccess?.status == "Retracted" &&
                authToken !== null &&
                authToken !== "" ?
                "Bid-btn-disabled" :
                "Bid-btn"}

                onClick={scheduleInterview}>
                  
                            <img
                  src={
                  userSKillListing?.bid?.length > 0 &&
                  interviewStatuses.includes(
                  userSKillListing?.bid[
                  userSKillListing?.bid?.length - 1]?.
                  BidStatusId) ?

                  schedule_icon_disable :
                  schedule_icon}

                  style={{ marginRight: "5px" }} />
                  
                            Schedule an interview
                          </button>
                        </Col>

                        <Col lg={24} xs={24}>
                          <button
                onClick={messageCandidate}
                className="msg-btn">
                  
                            <img
                  src={cil_chat_bubble}
                  className="social-icon" />
                  
                            Message candidate
                          </button>
                        </Col>
                      </>
                     :  isHiredOrOfferAccepted() ? (
                      <HiredStatusbtns
                        messageCandidate={messageCandidate}
                        chaticon={cil_chat_bubble}
                      />
                    ) : location.state?.fromMatches ||location.state?.searchType==TAL_AUTO_SUGGESTED||
                      location.search?.includes("matches") ? 
                      <>
                        <MatchesButton
              GigId={
              location.state?.jobId ??
              location.search.split("jobId=")[1]?.split("&")[0]}

              JobTitle={location.state?.JobTitle}
              SkillListingId={
              location.state?.id ??
              location.search.split("skillid=")[1]}

              SkillListingTitle={
              userSKillListing?.skill_listings?.Title}

              match={match}
              setMatch={setMatch}
              isTalentSuggestion={location.state?.searchType == TAL_AUTO_SUGGESTED} />
              
                        <Col lg={24} xs={24}>
                          <button
                className={
                !match || alreadyPlacedBid ?
                "Bid-btn-disabled" :
                "place-Bid-btn"}

                disabled={!match || alreadyPlacedBid}
                onClick={placeABidFunction}>
                  
                            Place a bid
                          </button>
                        </Col>
                        <Col lg={24} xs={24}>
                          <button
                            className={"Bid-btn-disabled"}
                            disabled={
                              userSKillListing?.bid?.length > 0 &&
                               isHiredOrOfferAccepted() &&
                              (authToken === null || authToken === "") &&
                              interviewStatuses.includes(
                                userSKillListing?.bid[
                                  userSKillListing?.bid?.length - 1
                                ]?.BidStatusId
                              ) &&
                              true
                            }
                            onClick={scheduleInterview}
                          >
                            <img
                  src={schedule_icon_fade}
                  style={{ marginRight: "5px" }} />
                  
                            Schedule an interview
                          </button>
                        </Col>
                        <Col lg={24} xs={24}>
                          <button
                className={"cand-prof-msg-btn-disabled"}
                onClick={messageCandidate}
                disabled={true}>
                  
                            <img
                  src={cil_chat_bubble_faded}
                  className="social-icon" />
                  
                            Message candidate
                          </button>
                        </Col>
                      </> :
            userSKillListing?.status == "pending" &&
            RetractSuccess?.status == "Retracted" ||
            userSKillListing?.status == "idle" ?
            <>
                        <Col lg={24} xs={24}>
                          <button
                className={
                alreadyPlacedBid ?
                "place-Bid-btn-disabled" :
                "place-Bid-btn"}

                onClick={placeABidFunction}
                disabled={alreadyPlacedBid}>
                  
                            Place a bid
                          </button>
                        </Col>
                          <Col lg={24} xs={24}>
                            <button
                className={
                alreadyPlacedBid ?
                "Bid-btn-disabled match-btn-pd-disabled" :
                "Bid-btn match-btn-pd"}

                onClick={handleAddToMatch}
                disabled={alreadyPlacedBid}>
                  
                              Add to matches
                            </button>
                          </Col>

                        <Col lg={24} xs={24}>
                          <button
                className={
                userSKillListing?.status == "idle" ||
                alreadyPlacedBid ||
                RetractSuccess?.status == "Retracted" &&
                authToken !== null &&
                authToken !== "" ?
                "Bid-btn-disabled" :
                "Bid-btn"}

                disabled={
                userSKillListing?.status == "idle" ||
                alreadyPlacedBid ||
                RetractSuccess?.status == "Retracted" &&
                authToken !== null &&
                authToken !== "" ?
                true :
                false}

                onClick={scheduleInterview}>
                  
                            <img
                  src={
                  userSKillListing?.status == "idle" ||
                  RetractSuccess?.status == "Retracted" &&
                  authToken !== null &&
                  authToken !== "" ?
                  schedule_icon_fade :
                  schedule_icon}

                  style={{ marginRight: "5px" }} />
                  
                            Schedule an interview
                          </button>
                        </Col>
                        <Col lg={24} xs={24}>
                          <button
                onClick={messageCandidate}
                className={
                userSKillListing?.status == "idle" ||
                alreadyPlacedBid ||
                RetractSuccess?.status == "Retracted" &&
                authToken !== null &&
                authToken !== "" ?
                "cand-prof-msg-btn-disabled" :
                "msg-btn"}

                disabled={
                userSKillListing?.status == "idle" ||
                alreadyPlacedBid ||
                RetractSuccess?.status == "Retracted" &&
                authToken !== null &&
                authToken !== "" ?
                true :
                false}>

                  
                            <img
                  src={
                  userSKillListing?.status == "idle" ||
                  RetractSuccess?.status == "Retracted" &&
                  authToken !== null &&
                  authToken !== "" ?
                  cil_chat_bubble_faded :
                  cil_chat_bubble}

                  className="social-icon" />
                  
                            Message candidate
                          </button>
                        </Col>
                      </> :

            <>
                        <Col lg={24} xs={24}>
                          <button
                className={
                alreadyPlacedBid ?
                "place-Bid-btn-disabled" :
                "place-Bid-btn"}

                onClick={placeABidFunction}
                disabled={alreadyPlacedBid}>
                  
                            Place a bid
                          </button>
                        </Col>
                          <Col lg={24} xs={24}>
                            <button
                className={
                alreadyPlacedBid ?
                "Bid-btn-disabled match-btn-pd-disabled" :
                "Bid-btn match-btn-pd"}

                onClick={handleAddToMatch}
                disabled={alreadyPlacedBid}>
                  
                              Add to matches
                            </button>
                          </Col>

                        <Col lg={24} xs={24}>
                          <button
                className={
                userSKillListing?.status == "idle" ||
                !alreadyPlacedBid ||
                RetractSuccess?.status == "Retracted" &&
                authToken !== null &&
                authToken !== "" ?
                "Bid-btn-disabled" :
                "Bid-btn"}

                disabled={
                userSKillListing?.status == "idle" ||
                alreadyPlacedBid ||
                RetractSuccess?.status == "Retracted" &&
                authToken !== null &&
                authToken !== "" ?
                true :
                false}

                onClick={scheduleInterview}>
                  
                            <img
                  alt="random"
                  src={
                  userSKillListing?.status == "idle" ||
                  !alreadyPlacedBid ||
                  RetractSuccess?.status == "Retracted" &&
                  authToken !== null &&
                  authToken !== "" ?
                  schedule_icon_fade :
                  schedule_icon}

                  style={{ marginRight: "5px" }} />
                  
                            Schedule an interview
                          </button>
                        </Col>
                        <Col lg={24} xs={24}>
                          <button
                onClick={messageCandidate}
                className={
                userSKillListing?.status == "idle" ||
                !alreadyPlacedBid ||
                RetractSuccess?.status == "Retracted" &&
                authToken !== null &&
                authToken !== "" ?
                "cand-prof-msg-btn-disabled" :
                "msg-btn"}

                disabled={
                userSKillListing?.status == "idle" ||
                !alreadyPlacedBid ||
                RetractSuccess?.status == "Retracted" &&
                authToken !== null &&
                authToken !== "" ?
                true :
                false}>

                  
                            <img
                  src={
                  userSKillListing?.status == "idle" ||
                  !alreadyPlacedBid ||
                  RetractSuccess?.status == "Retracted" &&
                  authToken !== null &&
                  authToken !== "" ?
                  cil_chat_bubble_faded :
                  cil_chat_bubble}

                  className="social-icon" />
                  
                            Message candidate
                          </button>
                        </Col>
                      </>}
            
                    {
            userProfileState?.EmployeeAssociation?.includes(
            Pdetails?.skill_listings ?
            Pdetails?.skill_listings[0]?.Profiles?.Accounts?.
            AccountId :
            null) ?

            <Col lg={24} xs={24}>
                        <button
              className={"remove-private-marketplace-btn"}
              onClick={removePvtTalent}>
                
                          {removePvtLoading ?
                <>
                              <Spin
                  indicator={
                  <LoadingOutlined
                  style={{
                    fontSize: 24,
                    color: "#fff"
                  }}
                  spin />} />


                  
                            </> :

                "Remove from private marketplace"}
                
                        </button>
                      </Col> :
            null}
                    {userSKillListing?.bidStatus?.placedBy || isInvited ?
            <Col span={24} style={{ marginTop: "15px" }}>
                        <PlaceBidDisclaimer
              email={
              userSKillListing?.bidStatus?.placedBy ||
              employerEmail}

              date={
              userSKillListing?.bidStatus?.bidPlacedAt ||
              inviteDate}

              isInvited={isInvited}
              employerName={employerName} />
              
                      </Col> :

            ""}
            
                  </Row>}
          

                {windowDimensions.width <= 769 &&
          <Select
          size={"large"}
          defaultValue="Skill listing"
          onChange={handleMenuClick}
          style={{
            width: "93%",
            display: "flex",
            justifyContent: "center",
            margin: "auto",
            marginBottom: "5%",
            marginTop: "5%"
          }}
          options={details} />}

          
                <div>
                 {Pdetails?.user_Schema?.Profiles?.Objective || Pdetails?.user_Schema?.Profiles?.Description ?
            <div className="summary-div">
                    {windowDimensions.width > 786 && <div className="Messages">Career Summary</div>}
                      <div className="career-summary">
                      {windowDimensions.width < 786 && <div className="Messages" style={{ paddingBottom: '12px' }}>Career Summary</div>}
                      <div
                className="career-text"
                dangerouslySetInnerHTML={{
                  __html: msgtxt(
                  Pdetails?.user_Schema?.Profiles?.Objective ?
                  Pdetails?.user_Schema?.Profiles?.Objective :
                  Pdetails?.user_Schema?.Profiles?.Description ?
                  Pdetails?.user_Schema?.Profiles?.Description :
                  null)

                }}>
                </div>
                    </div>
                   </div> : null}
                  {windowDimensions.width > 769 &&
            <h2 className="Messages"
            style={{
              marginTop: showBackButton ? "35px" : "0"
            }}>
                      {Pdetails?.skill_listings?.length > 0 &&
              Pdetails?.skill_listings[0].Title}
                    </h2>}
            
                  {menuClicked === "Education History" ?
            <EducationHistory
            data={
            Pdetails?.user_Schema?.Profiles?.
            Consultants_AcademicRecords} /> :

            menuClicked === "Reviews" ?
            <Reviews Reviews={Previews.reviews} /> :
            menuClicked === "Skill Listing" ?
            <SkillListing
            data={Pdetails?.skill_listings}
            isInvited={isInvited} /> :

            menuClicked === "Work History" ?
            <WorkHistory
            data={
            Pdetails?.user_Schema?.Profiles?.
            Consultants_CareerRecords} /> :


            menuClicked === "Add Note" ?
            <AddNotes skillListing={Pdetails?.skill_listings} /> :
            menuClicked === "Certifications & Awards" ?
            <CertificationAndAward
            data={
            Pdetails?.user_Schema?.Profiles?.
            Consultants_Certificates} /> :



            menuClicked === "Credentialing" &&
            <UserCredentials
            data={Pdetails?.user_Schema?.Profiles}
            error={error}
            setError={setError} />}


            
                </div>

                {windowDimensions.width > 769 &&
          <Row
          style={{
            width: "100%",
            height: "max-content"
          }}>
            
                    {/* here */}
                    <Col
            span={24}
            className="details-buttons-container"
            style={{ textAlign: "center" }}>
              
                      {skillloading ?
              <div style={{ width: "90%", margin: "auto" }}>
                          <Skeleton active />
                        </div> :
              isInvited ?
              <HiredStatusbtns
              chaticon={cil_chat_bubble}
              disChatIcon={cil_chat_bubble_faded}
              messageCandidate={messageCandidate}
              isInvited={isInvited} /> :

              !RetractSuccess &&
              userSKillListing?.bid?.length > 0 &&
              !bidDeclinedStatus &&
              !!!NegbidStatues[
              userSKillListing?.bid?.length > 0 &&
              userSKillListing?.bid[
              userSKillListing?.bid?.length - 1]?.
              BidStatusId] &&

              !isHiredOrOfferAccepted()  ?
              <>
                          <PlacedBidBtns
                jobId={location.state?.jobId}
                jobdetails={location.state?.jobdetails}
                fromMatches={location.state?.fromMatches}
                userSkillData={userSKillListing}
                skil_id={location.state?.id}
                HidePagePvt={HidePagePvt}
                setHidePagePvt={setHidePagePvt}
                disableDownloadButton={disableDownloadButton} />
                
                          <Col span={24}>
                            <button
                  disabled={
                  userSKillListing?.bid?.length > 0 &&
                  interviewStatuses.includes(
                  userSKillListing?.bid[
                  userSKillListing?.bid?.length - 1]?.
                  BidStatusId)}


                  className={
                  userSKillListing?.bid?.length > 0 &&
                  !!interviewStatuses.includes(
                  userSKillListing?.bid[
                  userSKillListing?.bid?.length - 1]?.
                  BidStatusId) ||

                  RetractSuccess?.status == "Retracted" &&
                  authToken !== null &&
                  authToken !== "" ?
                  "Bid-btn-disabled" :
                  "Bid-btn"}

                  onClick={scheduleInterview}>
                    
                              <img
                    src={
                    userSKillListing?.bid?.length > 0 &&
                    interviewStatuses.includes(
                    userSKillListing?.bid[
                    userSKillListing?.bid?.length - 1]?.
                    BidStatusId) ?

                    schedule_icon_disable :
                    schedule_icon}

                    style={{ marginRight: "5px" }} />
                    
                              Schedule an interview
                            </button>
                          </Col>

                          <Col lg={24} xs={24}>
                            <button
                  onClick={messageCandidate}
                  className="msg-btn">
                    
                              <img
                    src={cil_chat_bubble}
                    className="social-icon" />
                    
                              Message candidate
                            </button>
                          </Col>
                        </> :
              !isHiredOrOfferAccepted()  ?
              <HiredStatusbtns
              chaticon={cil_chat_bubble}
              disChatIcon={cil_chat_bubble_faded}
              messageCandidate={messageCandidate} /> :

              location.state?.fromMatches || location?.state?.searchType == TAL_AUTO_SUGGESTED ||
              location.search?.includes("matches") ?
              <>
                          <MatchesButton
                GigId={
                location.state?.jobId ??
                location.search.split("jobId=")[1]?.split("&")[0]}

                JobTitle={location.state?.JobTitle}
                SkillListingId={
                location.state?.id ??
                location.search.split("skillid=")[1]}

                SkillListingTitle={
                userSKillListing?.skill_listings?.Title}

                match={match}
                setMatch={setMatch}
                isTalentSuggestion={location.state?.searchType == TAL_AUTO_SUGGESTED} />
                
                          <Col lg={24} xs={24}>
                            <button
                  className={
                  !match || alreadyPlacedBid ?
                  "Bid-btn-disabled" :
                  "place-Bid-btn"}

                  disabled={!match || alreadyPlacedBid}
                  onClick={placeABidFunction}>
                    
                              Place a bid
                            </button>
                          </Col>
                          <Col lg={24} xs={24}>
                            <button
                  className={"Bid-btn-disabled"}
                  disabled={true}
                  onClick={scheduleInterview}>
                    
                              <img
                    src={schedule_icon_fade}
                    style={{ marginRight: "5px" }} />
                    
                              Schedule an interview
                            </button>
                          </Col>
                          <Col lg={24} xs={24}>
                            <button
                  className={"cand-prof-msg-btn-disabled"}
                  onClick={messageCandidate}
                  disabled={true}>
                    
                              <img
                    src={cil_chat_bubble_faded}
                    className="social-icon" />
                    
                              Message candidate
                            </button>
                          </Col>
                        </> :
              userSKillListing?.status == "pending" &&
              RetractSuccess?.status == "Retracted" ||
              userSKillListing?.status == "idle" ?
              <>
                          <Col lg={24} xs={24}>
                            <button
                  className={
                  alreadyPlacedBid ?
                  "place-Bid-btn-disabled" :
                  "place-Bid-btn"}

                  onClick={placeABidFunction}
                  disabled={alreadyPlacedBid}>
                    
                              Place a bid
                            </button>
                          </Col>
                            <Col lg={24} xs={24}>
                            <button
                  className={
                  alreadyPlacedBid ?
                  "Bid-btn-disabled match-btn-pd-disabled" :
                  "Bid-btn match-btn-pd"}

                  onClick={handleAddToMatch}
                  disabled={alreadyPlacedBid}>
                    
                              Add to matches
                            </button>
                          </Col>


                          <Col lg={24} xs={24}>
                            <button
                  className={
                  userSKillListing?.status == "idle" ||
                  RetractSuccess?.status == "Retracted" &&
                  authToken !== null &&
                  authToken !== "" ?
                  "Bid-btn-disabled" :
                  "Bid-btn"}

                  disabled={
                  userSKillListing?.status == "idle" ||
                  RetractSuccess?.status == "Retracted" &&
                  authToken !== null &&
                  authToken !== "" ?
                  true :
                  false}

                  onClick={scheduleInterview}>
                    
                              <img
                    src={
                    userSKillListing?.status == "idle" ||
                    RetractSuccess?.status == "Retracted" &&
                    authToken !== null &&
                    authToken !== "" ?
                    schedule_icon_fade :
                    schedule_icon}

                    style={{ marginRight: "5px" }} />
                    
                              Schedule an interview
                            </button>
                          </Col>
                          <Col lg={24} xs={24}>
                            <button
                  onClick={messageCandidate}
                  className={
                  userSKillListing?.status == "idle" ||
                  RetractSuccess?.status == "Retracted" &&
                  authToken !== null &&
                  authToken !== "" ?
                  "cand-prof-msg-btn-disabled" :
                  "msg-btn"}

                  disabled={
                  userSKillListing?.status == "idle" ||
                  RetractSuccess?.status == "Retracted" &&
                  authToken !== null &&
                  authToken !== "" ?
                  true :
                  false}>

                    
                              <img
                    src={
                    userSKillListing?.status == "idle" ||
                    RetractSuccess?.status == "Retracted" &&
                    authToken !== null &&
                    authToken !== "" ?
                    cil_chat_bubble_faded :
                    cil_chat_bubble}

                    className="social-icon" />
                    
                              Message candidate
                            </button>
                          </Col>
                        </> :

              <>
                          <Col lg={24} xs={24}>
                            <button
                  className={
                  alreadyPlacedBid ?
                  "place-Bid-btn-disabled" :
                  "place-Bid-btn"}

                  onClick={placeABidFunction}
                  disabled={alreadyPlacedBid}>
                    
                              Place a bid 
                            </button>
                          </Col>
                            <Col lg={24} xs={24}>
                            <button
                  className={
                  alreadyPlacedBid ?
                  "Bid-btn-disabled match-btn-pd-disabled" :
                  "Bid-btn match-btn-pd"}

                  onClick={handleAddToMatch}
                  disabled={alreadyPlacedBid}>
                    
                              Add to matches
                            </button>
                          </Col>

                          <Col lg={24} xs={24}>
                            <button
                  className={
                  userSKillListing?.status == "idle" ||
                  !alreadyPlacedBid ||
                  RetractSuccess?.status == "Retracted" &&
                  authToken !== null &&
                  authToken !== "" ||
                  userSKillListing?.status == "pending" ?
                  "Bid-btn-disabled" :
                  "Bid-btn"}

                  disabled={
                  !alreadyPlacedBid ||
                  userSKillListing?.status == "idle" ||
                  RetractSuccess?.status == "Retracted" &&
                  authToken !== null &&
                  authToken !== "" ||
                  userSKillListing?.status == "pending" ?
                  true :
                  false}

                  onClick={scheduleInterview}>
                    
                              <img
                    src={
                    userSKillListing?.status == "idle" ||
                    !alreadyPlacedBid ||
                    RetractSuccess?.status == "Retracted" &&
                    authToken !== null &&
                    authToken !== "" ||
                    userSKillListing?.status == "pending" ?
                    schedule_icon_fade :
                    schedule_icon}

                    style={{ marginRight: "5px" }} />
                    
                              Schedule an interview
                            </button>
                          </Col>
                          <Col lg={24} xs={24}>
                            <button
                  onClick={messageCandidate}
                  className={
                  userSKillListing?.status == "idle" ||
                  !alreadyPlacedBid ||
                  RetractSuccess?.status == "Retracted" &&
                  authToken !== null &&
                  authToken !== "" ?
                  "cand-prof-msg-btn-disabled" :
                  "msg-btn"}

                  disabled={
                  !alreadyPlacedBid ||
                  userSKillListing?.status == "idle" ||
                  RetractSuccess?.status == "Retracted" &&
                  authToken !== null &&
                  authToken !== "" ?
                  true :
                  false}>

                    
                              <img
                    src={
                    userSKillListing?.status == "idle" ||
                    !alreadyPlacedBid ||
                    RetractSuccess?.status == "Retracted" &&
                    authToken !== null &&
                    authToken !== "" ?
                    cil_chat_bubble_faded :
                    cil_chat_bubble}

                    className="social-icon" />
                    
                              Message candidate
                            </button>
                          </Col>
                        </>}
              
                      {
              userProfileState?.EmployeeAssociation?.includes(
              Pdetails?.skill_listings ?
              Pdetails?.skill_listings[0]?.Profiles?.Accounts?.
              AccountId :
              null) ?

              <Col lg={24} xs={24}>
                          <button
                className={"remove-private-marketplace-btn"}
                onClick={removePvtTalent}>
                  
                            {removePvtLoading ?
                  <>
                                <Spin
                    indicator={
                    <LoadingOutlined
                    style={{
                      fontSize: 24
                    }}
                    spin />} />


                    
                              </> :

                  "Remove from private marketplace"}
                  
                          </button>
                        </Col> :
              null}
                      <PopupModal
              popUpTrue={popUpTrue}
              setpopUpTrue={setpopUpTrue}
              id={
              Pdetails?.skill_listings?.length > 0 &&
              Pdetails?.skill_listings[0]?.Profiles?.Accounts?.
              AccountId}

              absAccountId={userProfile?.MasterAccountId || userProfile?.AccountId}
              show={showConfirmationModal}
              onClose={() => {
                setShowConfirmationModal(false);
              }} />
              
                    </Col>

                    {userSKillListing?.bidStatus?.placedBy || isInvited ?
            <Col span={24} style={{ marginTop: "15px" }}>
                        <PlaceBidDisclaimer
              email={
              userSKillListing?.bidStatus?.placedBy ||
              employerEmail}

              date={
              userSKillListing?.bidStatus?.bidPlacedAt ||
              inviteDate}

              isInvited={isInvited}
              employerName={employerName} />
              
                      </Col> :
            null}
                  </Row>}
          
              </div> :
        null}
          </div>}

      
    </>);

};

const ProfileDetailRemount = (props) => {
  const { id } = useParams();

  return <ProfileDetail {...props} key={id} />;
};

export default ProfileDetailRemount;
